var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D0D3DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4807 14.7H5.5343C5.52282 14.6891 5.51139 14.6781 5.5 14.667C5.9439 14.4236 6.17966 14.1626 6.4031 13.9153C6.66734 13.6228 6.91435 13.3494 7.46804 13.1467L7.46827 13.1466C8.34611 12.8399 8.47477 12.795 8.44449 12.0693C8.42973 11.8431 8.37717 11.7913 8.2956 11.7108C8.20988 11.6262 8.09211 11.51 7.95248 11.1266C7.95136 11.1233 7.95019 11.1198 7.94899 11.1162C7.91768 11.0231 7.85856 10.8473 7.77839 10.7824C7.59672 10.5804 7.14256 10.0492 7.36964 9.32346C7.45374 9.04638 7.44648 9.01147 7.41245 8.84783C7.40054 8.79053 7.38534 8.71746 7.36964 8.61269C7.28638 8.08896 7.27124 7.31084 7.48318 6.76467C7.87679 5.76958 8.83053 5.23837 10.1476 5.30571C10.7554 5.33432 10.9359 5.46624 11.1279 5.60658C11.2372 5.68646 11.3503 5.76907 11.5479 5.83692C12.5244 6.15864 12.9331 7.22106 12.6228 8.68002C12.5977 8.79039 12.5727 8.86414 12.5532 8.92149C12.5079 9.05462 12.4927 9.09932 12.5774 9.3085C12.7061 9.64518 12.6379 9.95194 12.5547 10.2213C12.4686 10.5047 12.4234 10.5331 12.3642 10.5703C12.2983 10.6116 12.2153 10.6638 12.0399 11.0892C11.9332 11.3393 11.7996 11.5159 11.6942 11.6553C11.5978 11.7828 11.5249 11.8791 11.5177 11.972C11.4196 12.7774 11.7276 12.8916 12.6289 13.2257L12.6379 13.229C12.8134 13.2921 13.1738 13.6027 13.553 13.9295C13.8935 14.2231 14.2493 14.5297 14.5 14.6819C14.4936 14.688 14.4872 14.694 14.4807 14.7Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconprofile);
export default __webpack_public_path__ + "static/media/Icon.profile.82ad79a69bc7d55cfb577ea4b8e3ad50.svg";
export { ForwardRef as ReactComponent };